export const EXPIRATION_DEFAULTS = { live: 1440, instagram: 30, manual: 120 };

export interface CheckoutExpirationConfig {
  live: number;
  instagram: number;
  manual: number;
}

export function getExpirationMinutes(
  config: CheckoutExpirationConfig | null | undefined,
  salesChannel: string | null | undefined
): number {
  const cfg = config ?? EXPIRATION_DEFAULTS;
  if (salesChannel === 'live') return cfg.live ?? EXPIRATION_DEFAULTS.live;
  if (salesChannel === 'story_shop') return cfg.instagram ?? EXPIRATION_DEFAULTS.instagram;
  return cfg.manual ?? EXPIRATION_DEFAULTS.manual;
}

export function minutesToDaysHoursMinutes(totalMinutes: number): { days: number; hours: number; minutes: number } {
  const days = Math.floor(totalMinutes / 1440);
  const hours = Math.floor((totalMinutes % 1440) / 60);
  const minutes = totalMinutes % 60;
  return { days, hours, minutes };
}

export function daysHoursMinutesToMinutes(days: number, hours: number, minutes: number): number {
  return (days * 1440) + (hours * 60) + minutes;
}
